export default __webpack_public_path__ + "static/media/splash-login-left.010034c9.svg";